


















































































































































































































































































































































import {
  computed,
  defineComponent,
  useContext,
  useRouter,
  ref,
  onMounted,
} from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import { useUiNotification } from "~/composables";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { useUiState } from "~/composables";
import { useUser } from "~/modules/customer/composables/useUser";
import { useCategoryMenuStore } from "~/stores/extensionApi";
import { checkCmsLink, direct_link } from "~/helpers";
import { useClevertapStore } from "~/stores/clevertap";

export default defineComponent({
  name: "HomePage",
  components: {
    LazyComponent,
  },
  setup() {
    const router = useRouter();
    const customerStore = useCustomerStore();
    const { send: sendNotification } = useUiNotification();
    const categoryMenuStore = useCategoryMenuStore();
    const newMegaMenu = computed(() => categoryMenuStore.getCategoryMenuMega);
    const {
      app: { i18n, $config },
    } = useContext();
    const { toggleLoginModal } = useUiState();
    const { isAuthenticated } = useUser();
    const { app } = useContext();
    const clevertapStore = useClevertapStore();

    // Newsletter subscription state
    const emailcustomer = ref('');
    const validationError = ref('');
    const isSubmitting = ref(false);
    const subscribeSuccess = ref(false);

    // Email validation function
    const isValidEmail = (email: string): boolean => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }

    // Submit email function
    const submitEmail = async () => {
      // Clear previous messages
      validationError.value = ''
      
      // Validate email
      if (!emailcustomer.value) {
        validationError.value = 'Vui lòng nhập địa chỉ email'
        // Send error notification
        sendNotification({
          id: Symbol("email-validation-error"),
          message: "Vui lòng nhập địa chỉ email",
          type: "warning",
          icon: "info",
          persist: false
        });
        return
      }
      
      if (!isValidEmail(emailcustomer.value)) {
        validationError.value = 'Địa chỉ email không hợp lệ'

        return
      }
      
      // Set submitting state
      isSubmitting.value = true
      
      try {
        // You would typically call an API here to register the email
        // For this example, we'll simulate a successful API call
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        // Track event in CleverTap
        const win = window as any
        if (typeof win !== 'undefined' && win.clevertap) {
          clevertapStore.emailSubscriberCleverTap({
            clevertap: win.clevertap,
            data: {
              email: emailcustomer.value,
              location: 'footer',
              url: process.env.VSF_STORE_URL || 'https://www.canifa.com',
            }
          })
        }
        
        // Show success message using sendNotification
        sendNotification({
          id: Symbol("email-subscription-success"),
          message: "Đăng ký nhận bản tin thành công!",
          type: "success",
          icon: "check",
          persist: false
        });
        
        // Show success state in modal
        subscribeSuccess.value = true;
        
        // Clear input field after successful submission
        emailcustomer.value = ''
      } catch (error) {
        console.error('Error submitting email subscription:', error)
        validationError.value = 'Có lỗi xảy ra, vui lòng thử lại sau'
        // Send error notification
        sendNotification({
          id: Symbol("email-subscription-error"),
          message: "Có lỗi xảy ra, vui lòng thử lại sau",
          type: "danger",
          icon: "cross",
          persist: false
        });
      } finally {
        isSubmitting.value = false
      }
    }

    const isTrademarksExpanded = ref(false);
    const isSupportExpanded = ref(false);

    const toggleTrademarks = () => {
      isTrademarksExpanded.value = !isTrademarksExpanded.value;
      if (isTrademarksExpanded.value) {
        isSupportExpanded.value = false;
      }
    };

    const toggleSupport = () => {
      isSupportExpanded.value = !isSupportExpanded.value;
      if (isSupportExpanded.value) {
        isTrademarksExpanded.value = false;
      }
    };

    const social = ["facebook", "pinterest", "twitter", "youtube"];
    const navigationSupport = [
      { title: i18n.t("Q&A"), link: "/hoi-dap" },
      { title: i18n.t("Loyalty Policy"), link: "/cms/khtt.html" },
      {
        title: i18n.t("Conditions - Terms and Conditions Policy"),
        link: "/cms/dieu-kien-dieu-khoan-khtt.html",
      },
      { title: i18n.t("Shipping Policy"), link: "/cms/van-chuyen.html" },
      
      { title: i18n.t("Check your order"), link: "/tra-don-hang" },
      {
        title: i18n.t("Size guide"),
        link: "/cms/huong-dan-chon-size.html",
      },
      {
        title: i18n.t("Look up card points"),
        link: "/customer/membership-card",
      },
      { title: i18n.t("Privacy policy"), link: "/cms/chinh-sach-bao-mat" },
    ];

    const navigationTrademark = [
      { title: i18n.t("About us"), link: "/cms/gioi-thieu.html" },
      { title: i18n.t("Store Locations"), link: "/cua-hang.html" },
      {
        title: i18n.t("Blog"),
        link: `https://canifa.com/blog/`,
        target: true,
      },
      {
        title: i18n.t("Recruitment"),
        link: `https://canifa.com/tuyen-dung/`,
        target: true,
      },
      { title: i18n.t("Community"), link: "/cms/voi-cong-dong.html" },      
      { title: i18n.t("Contact"), link: "/cms/lien-he.html" },
    ];

    const gotoUrl = (n) => {
      if (n.target) {
        window.open(n.link);
      } else {
        checkUrl(n);
      }
    };

    const checkUrl = (n) => {
      if (n.link && n.link.includes("customer")) {
        if (!isAuthenticated.value) {
          toggleLoginModal();
          return;
        }
        // Use localized route for customer pages
        router.push(app.localeRoute({ path: n.link }));
      } else {
        // For non-customer pages, use standard routing
        router.push(n.link);
      }
    };

    onMounted(async () => {
      if (
        !categoryMenuStore.getCategoryMenuMega ||
        categoryMenuStore.getCategoryMenuMega.length === 0
      ) {
        await categoryMenuStore.loadNewMenuMega();
      }
    });

    return {
      navigationTrademark,
      gotoUrl,
      navigationSupport,
      social,
      isTrademarksExpanded,
      toggleTrademarks,
      isSupportExpanded,
      toggleSupport,
      toggleLoginModal,
      isAuthenticated,
      newMegaMenu,
      checkCmsLink,
      direct_link,
      // Newsletter subscription props
      emailcustomer,
      validationError,
      isSubmitting,
      subscribeSuccess,
      submitEmail
    };
  },
  data() {
    return {
      activeIndex: null,
      isActiveSubscribe: false
    };
  },
  methods: {
    setActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
    activeSubscribe() {
      this.isActiveSubscribe = !this.isActiveSubscribe;
      // Reset form when opening or closing
      this.emailcustomer = '';
      this.validationError = '';
      this.subscribeSuccess = false;
    }
  },
});
